// extracted by mini-css-extract-plugin
module.exports = {"deleteButton":"deleteButton__2vAcr","mainWrapper":"mainWrapper__1IeH8","centralWrapper":"centralWrapper__3e_EJ","rightColumn":"rightColumn__3i8WQ"};